import { PAYMENTS_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TPaymentsSelector, TEqualityFunction } from '../types';

export const usePaymentsSelector = <TSelected>(
    selector: TPaymentsSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof PAYMENTS_REDUCER>(PAYMENTS_REDUCER, selector, equalityFn);
};
